import React from "react";

const MissionSection = (props) => {

    return (
        <section className="mission-vision-section">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="mission-vision-grids clearfix">
                            <div className="grid" style={{width:'47.5%'}}>
                                <div className="overlay"></div>
                                <h2>Our mission</h2>
                                <p>
                                    At <span style={{ fontWeight: "bold", fontSize: "1.01em" }}>Love of Hearts Foundation Incorporated</span>,
                                    we empower individuals and strengthen communities through education, mentorship, and compassionate support.
                                    Guided by our core values of integrity, respect, community, passion, and diversity, we are committed to creating
                                    opportunities that foster growth, resilience, and hope—ensuring no one faces life’s challenges alone.
                                </p>
                            </div>
                            <div className="grid" style={{width:'47.5%'}}>
                                <div className="overlay"></div>
                                <h2>Our vision</h2>
                                <p>A future where every dream, no matter how big or small, has the opportunity to become a reality.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="mission-vision-grids clearfix">
                            <div className="grid" style={{width:'100%'}}>
                                <div className="overlay"></div>
                                <h2>Our value</h2>
                                <p>
                                    <h5>Integrity:</h5> We uphold honesty, transparency, and accountability in
                                    all that we do—building trust through our actions and commitment to doing what’s right.
                                    <h5><span></span></h5>
                                    <h5>Respect:</h5> We value every individual, honoring their story, dignity, and potential.
                                    Every person matters and deserves to be treated with kindness and care.
                                    <h5><span></span></h5>
                                    <h5>Community:</h5> We believe in the power of unity and collaboration.
                                    Together, we create lasting impact by supporting and uplifting one another.
                                    <h5><span></span></h5>
                                    <h4>Passion:</h4> We serve with heart. Our work is fueled by compassion and a
                                    genuine desire to see lives transformed through love and opportunity.
                                    <h5><span></span></h5>
                                    <h5>Diversity:</h5>We embrace differences as strengths,
                                    creating spaces where people can learn, grow, and thrive together.
                                    <h5><span></span></h5>
                                    <h4>These core values collectively support your organization's goal of bridging the gap
                                    between dreams and reality, empowering women and children, and creating a better
                                        future for all.</h4>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MissionSection;